export default __webpack_public_path__ + "0de06d627367c2fa1004ebd9cae914e5.png";